import NUMERIC_CODES from '@/constants/iso-3166-numeric.json';



/*
  Map an ISO 3166-1 alpha-2 country code (e.g. "US", "GB", "JP") to its
  ISO 3166-1 numeric code (e.g. "840", "826", "392").

  3DS providers (Paay, Cardinal) expect the numeric form on the wire — see
  https://docs.3dsintegrator.com/docs/dom-elements and Cardinal's docs.

  Three chromium-published codes have no official ISO numeric assignment:
  AC (Ascension), TA (Tristan da Cunha), XK (Kosovo). For those — and for any
  unknown input — this returns null and callers should omit the field rather
  than send a wrong value.

  @param {string} alpha2
  @returns {string|null}
*/
function countryCodeToNumeric(alpha2) {
  if (!alpha2 || typeof alpha2 !== 'string') return null;
  const upper = alpha2.toUpperCase();
  return NUMERIC_CODES[upper] || null;
}



export default countryCodeToNumeric;
